module.exports = __webpack_public_path__ + "static/ecosystem-web-app-8a8fa017501c19c3fca67a2a03f21bda.png";